import { useContext } from "react";
import { GlobalContext } from "../../../../../../../../../util/state/GlobalContextProvider";
import { useRecoilState } from "recoil";
import { tenantsDealersState } from "../../../../../recoil";

export default function useFormTenantsDealers() {
    const { globalData } = useContext(GlobalContext);

    const [{ tenants, dealers }, setTenantsDealers] = useRecoilState(tenantsDealersState)

    const result = {
        tenants: tenants || globalData?.user?.legalEntities?.map((le:any) => le.name) || [],
        dealers: dealers || globalData?.user?.dealers?.map((d:any) => d.name) || [],
        setTenantsDealers,
    };

    return result;
}